<app-temp-modal-cadastro #modalCadastro [modalContentId]="'modal-cadastro-itens-manifesto'"
  (closed)="destroyComponent()" [textHeader]="'Dados necessários para NF-e de Venda'" customClass="modal-xxl">
  <div class="app-modal-body">
    <div class="row mb-3">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="form-radio form-control group border-0 p-0 m-0 d-flex align-items-center">
          <div class="radio radio-inline m-0 mr-4">
            <label class="m-0 cursor-pointer">
              <input type="radio" name="tipoAtribuicao" [checked]="tipoAtribuicao === 'todos'"
                (change)="setTipoAtribuicao('todos')">
              <i class="helper"></i><span>Atribuir para todos os itens da NF-e</span>
            </label>
          </div>
          <div class="radio radio-inline m-0">
            <label class="m-0 cursor-pointer">
              <input type="radio" name="tipoAtribuicao" [checked]="tipoAtribuicao === 'ncm'"
                (change)="setTipoAtribuicao('ncm')">
              <i class="helper"></i><span>Atribuir por NCM</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="ncm-tabs-container mb-3" *ngIf="tipoAtribuicao === 'ncm'">
      <div class="d-flex overflow-auto pb-2">
        <button *ngFor="let ncm of ncms" class="btn-ncm-tab" [class.active]="ncmSelecionado === ncm"
          (click)="setNcmSelecionado(ncm)">
          {{ ncm }}
        </button>
      </div>
    </div>

    <form [formGroup]="form">
      <div class="row">
        <div class="form-group col-sm-12">
          <label for="form_tipoItemid">Tipo de Produto</label>
          <ng-select id="form_tipoItemid" [items]="tipoItens" bindLabel="descricao" bindValue="id"
            formControlName="tipoItemid" placeholder="Selecione">
          </ng-select>
        </div>
      </div>

      <div class="row align-items-center mb-3">
        <div class="col-sm-6">
          <app-dim-checkbox label="Sujeito Subs. Tributária"
            formControlName="substituicaoTributaria"></app-dim-checkbox>
        </div>
        <div class="col-sm-6">
          <app-dim-checkbox label="Abater ICMS Base PIS/COFINS"
            formControlName="abaterICMSBasePISCOFINS"></app-dim-checkbox>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-6">
          <label>Alíquota ICMS para {{ estadoEmpresa }}</label>
          <ng-select [items]="aliquotasSelecionadas" bindLabel="aliquotaICMS" bindValue="id"
            formControlName="aliquotaicmsid" placeholder="Selecione">
            <ng-template ng-label-tmp let-item="item">
              {{ aliquotaIcmsSelectLabel(item) }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ aliquotaIcmsSelectLabel(item) }}
            </ng-template>
          </ng-select>
        </div>
        <div class="form-group col-sm-6">
          <label>Código ANP</label>
          <ng-select [items]="tipoProdutoANPMap" bindLabel="name" bindValue="id" formControlName="codigoANP"
            placeholder="Selecione">
          </ng-select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-12">
          <label>Origem Mercadoria</label>
          <ng-select [items]="origens" bindLabel="descricao" bindValue="id" formControlName="origemMercadoria"
            placeholder="Selecione">
          </ng-select>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <fieldset class="mb-3">
            <legend>ICMS</legend>
            <div class="fieldset-content form-control form-radio group" style="border: unset; padding: 0">
              <div class="radio radio-inline">
                <label class="cursor-pointer">
                  <input type="radio" formControlName="tipoDestaqueICMS" [value]="0">
                  <i class="helper"></i><span>Normal</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label class="cursor-pointer">
                  <input type="radio" formControlName="tipoDestaqueICMS" [value]="1">
                  <i class="helper"></i><span>Isento</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label class="cursor-pointer">
                  <input type="radio" formControlName="tipoDestaqueICMS" [value]="2">
                  <i class="helper"></i><span>Não Tributado</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label class="cursor-pointer">
                  <input type="radio" formControlName="tipoDestaqueICMS" [value]="3">
                  <i class="helper"></i><span>Suspenso</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label class="cursor-pointer">
                  <input type="radio" formControlName="tipoDestaqueICMS" [value]="4">
                  <i class="helper"></i><span>Diferido</span>
                </label>
              </div>
            </div>

            <div class="grid-beneficios-fiscais">
              <label for="form_codigoBeneficioFiscal">Código Benefício Fiscal</label>
              <app-combobox-cbenef-fiscais id="form_codigoBeneficioFiscal" label=""
                [appendTo]="'#modal-cadastro-itens-manifesto'" formControlName="codigoBeneficioFiscal"
                [customData]="customDataCBenef">
              </app-combobox-cbenef-fiscais>

              <label for="form_cCredPresumido">Cód. Benef. Crédito Presumido</label>
              <ng-select id="form_cCredPresumido" [loading]="loading['codigosCreditoPresumido']"
                formControlName="cCredPresumido" placeholder="Selecione" [items]="codigosCreditoPresumido"
                bindLabel="descricao" bindValue="codigo">
              </ng-select>

              <label for="form_pCredPresumido">% do Crédito Presumido</label>
              <div class="input-group" style="width: 150px">
                <input id="form_pCredPresumido" type="text" currencyMask
                  [options]="{prefix: '', precision: 2, allowNegative: false}" class="form-control"
                  formControlName="pCredPresumido">
                <span style="cursor: default" class="input-group-addon">%</span>
              </div>

              <ng-container *ngIf="form.get('tipoDestaqueICMS').value === 4"> <!-- Diferido -->
                <label for="form_percentualDiferimento">% Diferimento</label>
                <div class="input-group" style="width: 150px">
                  <input id="form_percentualDiferimento" type="text" currencyMask
                    [options]="{prefix: '', precision: 2, allowNegative: false}" class="form-control"
                    formControlName="percentualDiferimento">
                  <span style="cursor: default" class="input-group-addon">%</span>
                </div>

                <label for="form_percentualDiferimento">&nbsp;</label>
                <app-dim-checkbox label="Destacar ICMS" formControlName="destacarICMSItemDiferido"></app-dim-checkbox>
              </ng-container>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-8">
          <label>CST IPI</label>
          <ng-select [items]="situacaoTributariaIPI" bindLabel="name" bindValue="id"
            formControlName="ipiSituacaoTributaria" placeholder="Selecione">
          </ng-select>
        </div>
        <div class="form-group col-sm-4">
          <label>Alíquota IPI</label>
          <input class="form-control" type="text" formControlName="aliquotaipi" currencyMask
            [options]="{prefix: '', precision: 2}">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-8">
          <label>CST PIS</label>
          <ng-select [items]="situacaoTributariaPis" bindLabel="name" bindValue="id"
            formControlName="pisSituacaoTributaria" placeholder="Selecione">
          </ng-select>
        </div>
        <div class="form-group col-sm-4">
          <label>Alíquota PIS</label>
          <input class="form-control" type="text" formControlName="pis" currencyMask
            [options]="{prefix: '', precision: 4}">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-8">
          <label>CST COFINS</label>
          <ng-select [items]="situacaoTributariaCofins" bindLabel="name" bindValue="id"
            formControlName="cofinsSituacaoTributaria" placeholder="Selecione">
          </ng-select>
        </div>
        <div class="form-group col-sm-4">
          <label>Alíquota COFINS</label>
          <input class="form-control" type="text" formControlName="cofins" currencyMask
            [options]="{prefix: '', precision: 4}">
        </div>
      </div>
    </form>

    <div class="alert alert-secondary mt-3 mb-0">
      <i class="fa fa-info-circle mr-2"></i>
      O preenchimento desta tela é <strong>opcional</strong>. Caso prefira, você poderá informar estes dados posteriormente no cadastro de produtos.
    </div>

    <div class="text-right mt-3">
      <button class="btn btn-primary" (click)="aplicar()">
        Aplicar <i class="fa fa-arrow-right ml-1"></i>
      </button>
    </div>
  </div>
</app-temp-modal-cadastro>
<app-abrir-modal #abrirModal (closed)="onChildModalClosed($event)"></app-abrir-modal>